<template>
  <tbody
    v-if="lot && !loading"
    class="has-cells-vcentered is-size-6"
    :class="{'is-rowMoreInformations-visible': lotInfosOpen}">
    <tr
      class="is-size-6 table-rowMain"
      :class="{'tr--draft': lot.status === 'draft', 'is-rowMoreInformations-visible': lotInfosOpen, 'has-status-bar--left has-status-bar--draft': (actifPk ? actifPk === lot.pk : lastOpenedItemPk === lot.pk)}">
      <td class="has-text-centered is-paddingless">
        <multiselect-button
          v-if="multiselection"
          :data="lot" />
        <span
          v-else
          class="dot tooltip is-tooltip-right"
          :class="lot.status | programStatusClass"
          :data-tooltip="lot.status | statusLabel" />
      </td>
      <td class="is-narrow is-paddingless has-toggle-rowMoreInformations">
        <div>
          <router-link
            class="column is-padding-right-small is-padding-left-xsmall is-height-full columns is-gapless is-vcentered is-marginless is-cell-hoverable"
            :to="{name: 'LotVue', params: {id: lot.pk}}">
            <b>{{ lot.ref || '-' | truncateShort }}</b>
          </router-link>
          <a
            :id="`toggleLotInfos-${index}`"
            class="has-toggle-rowMoreInformations-toggle is-border-left is-height-full columns is-gapless is-vcentered is-marginless is-cell-hoverable"
            :class="{'has-background-black has-text-white': lotInfosOpen}"
            @click="toggleLotInfos">
            <div
              class="is-padding-small tooltip is-tooltip-right"
              :data-tooltip="'Détails'">
              <span class="icon">
                <i
                  v-if="lotInfosOpen && !loadinLotInfos"
                  class="fal fa-times" />
                <i
                  v-else-if="lotInfosOpen && loadinLotInfos"
                  class="fas fa-spinner fa-spin" />
                <i
                  v-else
                  class="fas fa-chevron-down" />
              </span>
            </div>
          </a>
        </div>
      </td>
      <router-link
        v-if="!isProgramView && showColumn('program__name')"
        class="is-cell-hoverable is-narrow"
        tag="td"
        :to="{name: 'ProgramVue', params: {id: lot.program.pk}}">
        <a :title="lot.program.name">
          <span class="is-size-6 has-text-grey">
            {{ lot.program.name | truncate(22) }}
          </span>
        </a>
      </router-link>
      <td
        v-if="isAdmin && isDistributeur && showColumn('promoteur__name') && isPromoteurDetailsActivated"
        class="is-cell-hoverable is-narrow">
        <router-link
          :to="{name: 'PromoteurPresentation', params: {id: lot.promoteur.pk}}">
          <span class="">{{ lot.promoteur.name | truncate }}</span>
        </router-link>
      </td>
      <td
        v-if="isAdmin && isDistributeur && showColumn('promoteur__name') && !isPromoteurDetailsActivated"
        class="is-nowrap">
        {{ lot.promoteur.name | truncate }}
      </td>

      <td
        v-if="!isProgramView && showColumn('address__zip_code')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.program.address && lot.program.address.zip_code">
          {{ lot.program.address.zip_code || '' }}
        </span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isProgramView && showColumn('address__city')"
        class="is-nowrap has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.program.address && lot.program.address.city">
          {{ lot.program.address.city | truncate }}
        </span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('nature')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.nature">{{ lot.nature | natureLabel }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('operation_type')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.program && lot.program.operation_type">{{ lot.program.operation_type | operationTypeLabel }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('lot_type')"
        class="has-cursor-pointer is-narrow"
        @click="toggleLotInfos">
        <span v-if="lot.lot_type">{{ lot.lot_type | lotTypeLabel }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('lot_subtype')"
        class="has-cursor-pointer is-narrow"
        @click="toggleLotInfos">
        <span
          v-if="lot.lot_subtype && lot.lot_subtype.length > 0"
          :title="lot.lot_subtype | prettySubtype(subtypesData)">
          {{ lot.lot_subtype | prettySubtype(subtypesData) }}
        </span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('surface')"
        class="is-nowrap has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.surface">{{ lot.surface | prettyPrice }} m²</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('tranche')"
        class="has-cursor-pointer is-nowrap"
        @click="toggleLotInfos">
        <span v-if="lot.tranche && lot.program.use_tranche">{{ lot.tranche.name }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('building')"
        class="has-cursor-pointer is-nowrap"
        @click="toggleLotInfos">
        <span v-if="lot.building">{{ lot.building.name }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('floor')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.floor">{{ lot.floor | floorLabel }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('exposures')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.exposures && lot.exposures.length">{{ lot.exposures | exposuresShortLabel }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('parking')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.parking_count">{{ lot.parking_count }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('sale_price_ht')"
        class="is-nowrap has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.sale_price_ht && !lot.tva_on_marge">{{ lot.sale_price_ht | prettyPrice }} €</span>
        <span v-else-if="lot.tva_on_marge">TVA sur marge</span>
        <span v-else>-</span>
      </td>
      <td
        class="is-nowrap has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.sale_price_ttc">{{ lot.sale_price_ttc | prettyPrice }} €</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('rent')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.rent">{{ lot.rent | prettyPrice }} €</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('capped_rent')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.capped_rent">{{ lot.capped_rent | prettyPrice }} €</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('rent') && isAdmin"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.rent">{{ lot.rent }}€</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('tax_dispositifs')"
        class="is-nowrap has-cursor-pointer"
        @click="toggleLotInfos">
        <span
          v-if="lot.tax_dispositifs && lot.tax_dispositifs.length > 0"
          :title="lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)">
          {{ lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData) | truncate }}
        </span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('profitability')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.profitability">{{ lot.profitability | prettyPrice }} %</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="!isParkingList && showColumn('capped_profitability')"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.capped_profitability">{{ lot.capped_profitability | prettyPrice }} %</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('date_livraison') && !isLotView && !isProgramView"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="(lot.building && lot.building.date_livraison) || lot.program.date_livraison">{{ lot.building ? lot.building.date_livraison : lot.program.date_livraison | prettyTrimestre }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('date_actabilite') && !isLotView && !isProgramView"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.program.date_actabilite">{{ lot.program.date_actabilite | prettyTrimestre }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('created_on') && isAdmin"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.created_on">{{ lot.created_on | date }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('options') && (isAdmin || isManagerPlus)"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.options">{{ lot.options.length != 0 ? lot.options.length : '-' }}</span>
        <span v-else>-</span>
      </td>
      <td
        v-if="showColumn('sales_mode') && isAdmin"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.sales_mode">{{ lot.sales_mode[0] }}</span>
        <span v-else>-</span>
      </td>

      <!-- <td
        v-if="showColumn('rent') && isAdmin"
        class="has-cursor-pointer"
        @click="toggleLotInfos">
        <span v-if="lot.rent">{{ lot.rent }}€</span>
        <span v-else>-</span>
      </td> -->
      <td class="has-text-centered actions">
        <display-button-list
          :force-drop-down="true"
          :data="lot"
          :buttons="buttonList"
          @hover="buttonListHover(lot)" />
      </td>
    </tr>
    <lot-row-infos
      v-if="lotInfosOpen"
      :id="'lotrow-' + lot.pk"
      :key="'lotrow-' + lot.pk"
      class="table-rowMoreInformations"
      :index="index"
      :source-lot="lot"
      @deleteFromWishlist="deleteFromWishlist"
      @toggleLotInfos="toggleLotInfos"
      @loading="val => loadinLotInfos = val" />
  </tbody>
</template>

<script>
import LotMixin from '../lots/LotMixin'
import { Multiselection } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'LotRow',
  components: {
    LotRowInfos: () => import('./LotRowInfos')
  },
  mixins: [LotMixin, Multiselection],
  props: {
    index: Number,
    columnsLotRow: Array,
    totalLotRow: Number,
    isProgramView: Boolean,
    isLotView: Boolean,
    displayDetails: Boolean,
    isParkingList: Boolean,
    fromWishList: {
      type: Boolean,
      default: false
    },
    actifPk: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      lotInfosOpen: false,
      loadinLotInfos: false,
      lotInfoPrograms: [],
      buttonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'LotVue', params: { id } })
          },
          icon: 'fa-file-invoice',
          text: 'Fiche lot',
          display: (lot) => {
            return !this.fromWishList
          }
        },
        // {
        //   icon: 'fas fa-download',
        //   text: 'Télécharger le plan',
        //   action: (id) => {
        //     let selectedLot = this.items.find(x => x.pk === id)
        //     this.downloadFile(selectedLot.documents, selectedLot.ref, '.zip')
        //   },
        //   display: (lot) => {
        //     return lot.documents && lot.documents.length
        //   }
        // },
        // {
        //   icon: 'fas fa-flag',
        //   text: 'Poser option',
        //   action: (id) => {
        //     this.selectedLot = id
        //     this.$router.push({name: 'OptionCreate', query: {lot: id, returnId: id, page: this.currentPage}})
        //   },
        //   display: (lot) => {
        //     if (this.isOperator || this.isEditor) {
        //       return false
        //     }
        //     const option = this.runningOptions.find(o => o.lot === lot.pk)
        //     if (option && option.seller === this.currentUserPk && option.status === 'pending') {
        //       return false
        //     }
        //     const program = this.lotInfoPrograms.find(p => p.pk === lot.program)
        //     return program && this.canBeOptioned(lot.status, program)
        //   }
        // },
        {
          icon: 'fa-trash-alt',
          text: 'Supprimer des favoris',
          action: (id) => {
            this.deleteFromWishlist(id)
          },
          display: (lot) => {
            return this.fromWishList
          }
        },
        {
          action: (id) => {
            this.$router.push({ name: 'LotEdit', params: { id } })
          },
          icon: 'fa-edit',
          text: 'Modifier fiche lot',
          needProfile: ['admin', 'editor'],
          display: (lot) => {
            return this.isAdmin && this.isPromoteur && !this.fromWishList
          }
        },
        {
          action: (id) => {
            this.deleteLot(id)
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer lot',
          needProfile: ['admin'],
          display: (lot) => {
            return this.isAdmin && this.isPromoteur && !this.fromWishList
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['accounts', 'isManagerPlus']),
    isPromoteurDetailsActivated () {
      return this.accounts.find(a => a.name === this.lot.promoteur.name).promoteur_details_activated
    }
  },
  watch: {
    displayDetails () {
      if (this.displayDetails) this.lotInfosOpen = false
      else this.lotInfosOpen = true
      this.toggleLotInfos()
    }
  },
  created () {
    if (this.displayDetails && !this.lotInfosOpen) this.toggleLotInfos()
  },
  methods: {
    showColumn (c) {
      return this.columnsLotRow.includes(c)
    },
    toggleLotInfos () {
      if (!this.lotInfosOpen) {
        setTimeout(() => {
          this.lotInfosOpen = !this.lotInfosOpen
        }, 1000)
      } else this.lotInfosOpen = !this.lotInfosOpen
      // if (this.lotInfosOpen) {
      //   setTimeout(() => {
      //     let container = '#app'
      //     if (document.querySelector('.table-wrapper')) container = '.table-wrapper'
      //     this.$scrollTo(`#lotrow-${this.lot.pk}`, 500, { container })
      //   }, 300)
      // }
    },
    getLotItems () {
      return null
    },
    async buttonListHover (lot) {
      // const lotInList = this.lotInfoPrograms.find(p => p.pk === lot.program.pk)
      // if (!lotInList) {
      //   try {
      //     const { data } = await this.$api.getOne(this.$resources.PROGRAM, lot.program.pk)
      //     this.lotInfoPrograms.push(data)
      //   } catch (e) {
      //     console.log(e)
      //   }
      // }
    }
  }
}
</script>
